import { useEffect, useState } from "react";
import ReactExport from "react-export-excel";
import { Grid, Button, Divider, IconButton, Tooltip } from "@material-ui/core";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import TablePedidos from "../components/table-pedidos";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import LoadingData from "components/Loading/LoadingData";
import TableChartIcon from "@mui/icons-material/TableChart";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const statusOptions = [
  { id: "todos", Nome: "Todos" },
  { id: "totalmente_faturado", Nome: "Totalmente Faturado" },
  { id: "parcialmente_faturado", Nome: "Parcialmente Faturado" },
];

const statusMap = {
  todos: "TODOS",
  totalmente_faturado: "Totalmente Faturado",
  parcialmente_faturado: "Parcialmente Faturado",
};

const ExportComponent = ({ data, dataInicial, dataFinal, loading }) => {
  return (
    <ExcelFile
      element={
        <Tooltip title="Exportar Excel">
          <IconButton size="small" disabled={loading} color="gray">
            <TableChartIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      }
      filename={`pedidos-${dataInicial || ""}-${dataFinal || ""}`}
    >
      <ExcelSheet data={data} name="Pedidos">
        <ExcelColumn label="Pedido" value="NumeroPedido" />
        <ExcelColumn label="Proposta" value="NumeroProposta" />
        <ExcelColumn label="CNPJ" value="Cnpj" />
        <ExcelColumn label="Razão Social" value="RazaoSocial" />
        <ExcelColumn label="Status" value="Status" />
        <ExcelColumn label="Data Pedido" value="DataPedido" />
        <ExcelColumn label="Última Confirmação" value="UltimaConfirmacao" />
        <ExcelColumn label="Prazo Entrega" value="PrazoEntrega" />
        <ExcelColumn label="Representante" value="NomeRepresentante" />
        <ExcelColumn label="Valor Faturado" value="ValorFaturado" />
        <ExcelColumn label="Valor em Aberto" value="ValorEmAberto" />
        <ExcelColumn label="Marca" value="Marca" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export default function Pedidos({
  structureFilters,
  cnpj = "",
  dataInicial,
  dataFinal,
}) {
  const [status, setStatus] = useState(statusOptions[0]);
  const [data, setData] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();
  const hasStructure =
    structureFilters?.idGrupoEconomico || structureFilters?.idLoja?.length;

  const handleFilter = async () => {
    if (!hasStructure && !cnpj) {
      snackbar.showMessage(
        "Selecione Grupo econômico e/ou Lojas e/ou Marcas e/ou Linha OU informe CNPJ e/ou Marca e/ou Linha",
        { severity: "error" }
      );
      return;
    }

    setLoading(true);

    try {
      const params = new URLSearchParams({
        idMarca: structureFilters?.idMarca || "TODAS",
        idGrupoEconomico: structureFilters?.idGrupoEconomico || "",
        idLoja: structureFilters?.idLoja?.length ? structureFilters.idLoja : "",
        cnpj: structureFilters?.cnpj?.replace(/\D/g, "") || "",
        dtIni: dataInicial,
        dtFim: dataFinal,
        status: statusMap[status?.id] || "TODOS",
      });

      [...params.entries()]
        .filter(
          ([, value]) => value === undefined || value === null || value === ""
        )
        .forEach(([key]) => params.delete(key));

      const response = await Api.get(
        "visao360-pedidos",
        "reportApp",
        `?${params.toString()}`,
        true
      );

      const responseData = response?.Result;

      setData(responseData?.Pedidos || responseData);
      setTotalRegistros(responseData?.TotalRegistros || responseData?.length);
    } catch (err) {
      snackbar.showMessage(err.message || "Erro ao carregar dados de pedidos", {
        severity: "error",
      });
      setData([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <Grid container spacing={2} style={{ margin: "1rem 0 0", alignItems: "center" }}>
        <Grid item xs={12} md={4} lg={3}>
          <AutoCompleteField
            label="Status"
            options={statusOptions}
            value={status}
            onChange={setStatus}
            optionLabelKey="Nome"
            optionIdKey="id"
          />
        </Grid>
        <Grid item xs={12} md={1} lg={1} style={{ marginTop: "1.25rem" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleFilter({})}
            disabled={loading}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} style={{ margin: "1rem 0" }}>
          <Divider />
        </Grid>
      </Grid>

      {loading && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingData searching label="Buscando dados de pedidos..." />
          </Grid>
        </Grid>
      )}

      {!loading && (
        <TablePedidos
          data={data}
          totalRegistros={totalRegistros}
          loading={loading}
          showPrint
          extraActions={<ExportComponent data={data} dataInicial={dataInicial} dataFinal={dataFinal} loading={loading} />}
        />
      )}
    </>
  );
}
